import Deprecated__ButtonLink from "./ButtonLink";

export default Deprecated__ButtonLink;
